import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';
import ParticleEmitter from '../particles/ParticleEmitter';

export default class LevelSelectScene extends Scene {
	constructor() {
		super();

		this._levelArray = [];
		this.completedLevels = null;
		this.unlockedLevels	= null;
		this._levelcontainer = null;
		this._muteButton = null;
		this._homeButton = null;
		this._leftButton = null;
		this._rightButton = null;
		this._caretText = null;
		this._competitionText = null;
		this._competitionFrame = null;
		this._scoreFrame = null;
		this._competitionButton = null;
		this._greenParticles = null;
		this._music = null;

		this._pointerdown = false;
		this._pointermoved = false;
		this._lastX = null;
		this._originalPoint = null;
		this._containerPoint = new PIXI.Point();
		this._levelBG = null;
		this._closestLevel = null;

		this._CMF = null;
		this._levels = P3.assets.json('level_data');

		this._levelBGAlts = [
        	P3.assets.texture('level_select_bg_zone1_1x'),
        	P3.assets.texture('level_select_bg_zone3_1x'),
        	P3.assets.texture('level_select_bg_zone2_1x')
		];

		this._scrollindex = 0;

		this.paused = false;
		this.signals.pause = new P3.utils.MiniSignal();
	}

	init() {
		super.init();

		this.interactive = true;

		this._CMF = new PIXI.filters.ColorMatrixFilter();
		this._CMF.desaturate();

		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));

		bg.anchor.set(0.5);
		bg.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT * 0.5);
		bg.width = 2000;
		this.addChild(bg);

		this._levelBG = new PIXI.Sprite(this._levelBGAlts[0]);
		this._levelBG.anchor.set(0.5);
		this._levelBG.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT * 0.5);
		this._levelBG.scale.set(P3.View.width / this._levelBG.texture.width);
		this.addChild(this._levelBG);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		this.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(0, 0);
		frameTop1.scale.x = -1;
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(1, 1);
		frameBottom2.scale.x = -1;
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT);
		frameTop.position.set((common.STAGE_WIDTH * 0.5), frameTop.height);

		const titletext = Text(`// ${translate('MENU.SELECT_LEVEL.TITLE')}`, {font: '48px ZCOOL QingKe HuangYou', align: 'center'});
		titletext.tint = 0xB3FF47;
		titletext.anchor.set(0.5);
		titletext.position.set((common.STAGE_WIDTH * 0.5), 60);
		this.addChild(titletext);

		const caretText = Text('_', {font: '48px ZCOOL QingKe HuangYou', align: 'center'});
		caretText.tint = 0xB3FF47;
		caretText.anchor.set(0, 0.5);
		caretText.position.set(titletext.x + (titletext.width * 0.5) + 10, 62);
		this.addChild(caretText);

		new P3.utils.TWEEN.Tween(caretText, this.tweens)
			.to({
				alpha: 0
			}, 1)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.yoyo(true)
			.repeat(Infinity)
			.start();

		const levellink = new PIXI.Sprite(P3.assets.texture('ui_level_link'));
		levellink.anchor.set(0.5);
		levellink.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT * 0.5);
		this.addChild(levellink);

		this._createLevels();

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_chevron_out');
		states.over = P3.assets.texture('ui_btn_chevron_over');
		states.down = P3.assets.texture('ui_btn_chevron_down');

		this._rightButton = new P3.Button(states);
		this._rightButton.clickSoundName = 'sfx_btn_press_00';
		this._rightButton.overSoundName = 'sfx_btn_rollover_00';
		this._rightButton.signals.click.add(this.onNextButtonClick, this);
		this._rightButton.signals.down.add(() => {
			this._rightButton.isPressed = true;
		});
		this._rightButton.signals.up.add(() => {
			this._rightButton.isPressed = false;
		});
		this._rightButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 50, common.STAGE_HEIGHT - 250);
		this._rightButton.isPressed = false;
		this.addChild(this._rightButton);

		this._leftButton = new P3.Button(states);
		this._leftButton.clickSoundName = 'sfx_btn_press_00';
		this._leftButton.overSoundName = 'sfx_btn_rollover_00';
		this._leftButton.signals.click.add(this.onPrevButtonClick, this);
		this._leftButton.signals.down.add(() => {
			this._leftButton.isPressed = true;
		});
		this._leftButton.signals.up.add(() => {
			this._leftButton.isPressed = false;
		});
		this._leftButton.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 50, common.STAGE_HEIGHT - 250);
		this._leftButton.scale.x = -1;
		this._leftButton.isPressed = false;
		this.addChild(this._leftButton);

		if (common.config.competition_enabled) {
			this._createCompetitionFrame();
		}

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_home');

		this._homeButton = new P3.Button(states);
		this._homeButton.clickSoundName = 'sfx_btn_press_00';
		this._homeButton.overSoundName = 'sfx_btn_rollover_00';
		this._homeButton.signals.click.add(() => {
			this.signals.previous.dispatch(this);
		}, this);
		this._homeButton.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 75, 75);
		this.addChild(this._homeButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_sound_on');
		states.iconAlt = P3.assets.texture('ui_icon_sound_off');

		this._muteButton = new P3.MuteButton(states);
		this._muteButton.signals.click.add(common.toggleAudio);
		this._muteButton.clickSoundName = 'sfx_btn_press_00';
		this._muteButton.overSoundName = 'sfx_btn_rollover_00';
		this._muteButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 75, 75);
		this.addChild(this._muteButton);

		this.on('pointerdown', this.onPointerDown);
		this.on('pointermove', this.onPointerMove);
		this.on('pointerup', this.onPointerUp);
		this.on('pointerupoutside', this.onPointerUp);

		let totalscore = 0;
		for (const i in this.completedLevels) {
			totalscore += this.completedLevels[i].highscore;
		}

		common.totalScore = totalscore;
	}

	_createLevels() {
		this.completedLevels = JSON.parse(localStorage.getItem('completed_levels')) || {};
		this._levelcontainer = new PIXI.Container();
		this.addChild(this._levelcontainer);

		let i = 0;
		let prevlocked = false;

		for (const item in this._levels) {
			const data = this._levels[item];

			if (data.debug_only) {
				continue;
			}

			prevlocked = !this.completedLevels.hasOwnProperty(i - 1);

			const level = this._createLevelButton(data, prevlocked, i);

			level.position.set(i * 300, 0);
			this._levelcontainer.addChild(level);
			this._levelArray.push(level);

			i++;
		}

		this._levelcontainer.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT * 0.5);
		// this._levelArray[this._scrollindex].y -= 50;
	}

	_createLevelButton(data, prevlocked = false, index) {
		const container = new PIXI.Container();

		const top = new PIXI.Sprite(P3.assets.texture('ui_level_top'));
		top.anchor.set(0.5);
		top.position.set(0, -140);
		container.addChild(top);

		const stagenumber = Text((index + 1).toString(), {font: '42px ZCOOL QingKe HuangYou', align: 'center'});
		stagenumber.tint = 0xFFFFFF;
		stagenumber.anchor.set(0.5);
		stagenumber.position.set(0, 0);
		top.addChild(stagenumber);

		const middle = new PIXI.Sprite(P3.assets.texture('ui_level_middle'));
		middle.anchor.set(0.5);
		middle.position.set(0, 0);
		container.addChild(middle);

		const bottom = new PIXI.Sprite(P3.assets.texture('ui_level_bottom'));
		bottom.anchor.set(0.5);
		bottom.position.set(0, 120);
		container.addChild(bottom);

		const iconContainer = new PIXI.Container();

		middle.addChild(iconContainer);

		let locked = false;

		if (this.completedLevels.hasOwnProperty(index) || data.filename === 'stage_1' || !prevlocked || common.cheatActive) {
			// do nothing, too lazy to do it the other way, sorry
		} else {
			const icon = new PIXI.Sprite(P3.assets.texture('ui_level_lock'));

			icon.anchor.set(0.5);
			icon.position.set(0, -10);
			icon.scale.set(0.8);
			middle.addChild(icon);
			locked = true;

			iconContainer.alpha = 0.4;
			iconContainer.y += 30;
		}

		const numAliens = data.allowedAliens.length;

		if (numAliens > 2) {
			iconContainer.scale.set(0.8);
		}

		const iconPositions = [
        	[[0, 0]],
        	[[-40, 0], [40, 0]],
        	[[-40, -24], [40, -24], [0, 48]],
        	[[-40, -40], [40, -40], [-40, 40], [40, 40]]
		];

		for (let i = 0; i < iconPositions[numAliens - 1].length; i++) {
			const icon = new PIXI.Sprite(P3.assets.texture(`ui_function_char_${data.allowedAliens[i]}`));
			const pos = iconPositions[numAliens - 1][i];
			icon.anchor.set(0.5);
			icon.x = pos[0];
			icon.y = pos[1];
			iconContainer.addChild(icon);
		}

		const scoreContainer = new PIXI.Container();

		const trophyIcon = new PIXI.Sprite(P3.assets.texture('ui_icon_hi_score'));
		trophyIcon.anchor.set(0, 0.5);
		trophyIcon.scale.set(0.7);
		trophyIcon.position.set(0, 0);
		scoreContainer.addChild(trophyIcon);

		const score = this.completedLevels[index] ? this.completedLevels[index].highscore : 0;
		const scoreText = Text(`${score}`, {font: '38px Ahkio Regular', align: 'center'});
		scoreText.tint = 0xFFFFFF;
		scoreText.anchor.set(0, 0.5);
		scoreText.position.set(trophyIcon.x + (trophyIcon.width * 0.5) + 20, 0);
		scoreContainer.addChild(scoreText);

		scoreContainer.position.set(scoreContainer.width * -0.5, -80);
		middle.addChild(scoreContainer);

		// stars
		if (this.completedLevels.hasOwnProperty(index) && this.completedLevels[index].score >= 1) {
			const star1 = new PIXI.Sprite(P3.assets.texture('ui_level_star'));

			star1.anchor.set(0.5);
			star1.position.set(-52, 110);
			container.addChild(star1);

			if (this.completedLevels[index].score >= 2) {
				const star2 = new PIXI.Sprite(P3.assets.texture('ui_level_star'));

				star2.anchor.set(0.5);
				star2.position.set(0, 122);
				container.addChild(star2);

				if (this.completedLevels[index].score >= 3) {
					const star3 = new PIXI.Sprite(P3.assets.texture('ui_level_star'));

					star3.anchor.set(0.5);
					star3.position.set(52, 110);
					container.addChild(star3);
				}
			}
		}
		// stars end

		container.interactive = true;
		container.index = index;
		container.buttonMode = true;
		container.on('pointertap', () => {
			if (locked) {
				return;
			}
			P3.audio.playSound('sfx_btn_press_00');
			this.onLevelSelect(index);
		});

		return container;
	}

	_createCompetitionFrame() {
		const competitionPanel = new PIXI.mesh.NineSlicePlane(P3.assets.texture('collectables_splash_panel'), 10, 10, 10, 10);
		this.addChild(competitionPanel);

		this._competitionFrame = new PIXI.Container();
		this._competitionFrame.bg = competitionPanel;
		this.addChild(this._competitionFrame);

		const cookie = JSON.parse(localStorage.getItem('competition_entry'));
		const competitionAllowed = this.completedLevels.hasOwnProperty('1') || common.cheatActive;

		if (cookie) {
			this._scoreFrame = new PIXI.Container();
			this._competitionFrame.addChild(this._scoreFrame);

			this._competitionText = Text(translate('MENU.SELECT_LEVEL.COMPETITION.YOURSCORE'), {font: '24px Ahkio Thin', align: 'center'});
			this._competitionText.tint = 0xFFFFFF;
			this._competitionText.maxWidth = 380;
			this._competitionText.anchor.set(0, 0.5);
			this._scoreFrame.addChild(this._competitionText);

			let scoreText = Text('', {font: '28px Ahkio Regular', align: 'center'});
			scoreText.tint = 0xABF546;
			scoreText.maxWidth = 380;
			scoreText.anchor.set(0, 0.5);
			this._scoreFrame.addChild(scoreText);
			this._competitionFrame.scoreText = scoreText;

			const subheader = Text('', {font: '16px Ahkio Thin', align: 'center'});
			subheader.maxWidth = 380;
			subheader.tint = 0xFFFFFF;
			subheader.anchor.set(0.5);
			this._competitionFrame.addChild(subheader);
			this._competitionFrame.subheader = subheader;

			scoreText.position.set(this._competitionText.x + this._competitionText.width + 10, this._competitionText.y);
			this._scoreFrame.position.set(this._scoreFrame.width * -0.5, competitionPanel.height * -0.5 + 20);
			subheader.position.set(0, 20);

			new Promise((resolve, reject) => {
				this.getCompetitionEntry(cookie.payload.id, resolve, reject);
			}).then((data) => {
				common.competitionData = data.payload;
				scoreText.text = `${data.payload.score}`;
				subheader.text = translate('MENU.SELECT_LEVEL.COMPETITION.PARENTAL_CONSENT');

				scoreText.position.set(this._competitionText.x + this._competitionText.width + 10, this._competitionText.y);
				this._scoreFrame.position.set(this._scoreFrame.width * -0.5, competitionPanel.height * -0.5 + 20);
				subheader.position.set(0, 20);

				this.resizeFrame();
			}).catch((data) => {
				console.error('Failed getting compeitition entry', data);
			});
		} else if (competitionAllowed) {
			this._competitionButton = new PIXI.mesh.NineSlicePlane(P3.assets.texture('competition_9slice_btn_off'), 70, 30, 70, 30);
			this._competitionButton.height = 75;
			this._competitionButton.interactive = this._competitionButton.buttonMode = true;
			this._competitionButton.on('pointertap', () => {
				this._competitionButton.visible = false;
				this.showCompetitionOverlay();
			}, this);
			this._competitionFrame.addChild(this._competitionButton);

			let buttonLabel = Text(translate('MENU.SELECT_LEVEL.COMPETITION.HEADER'), {font: '32px Ahkio Regular', align: 'center'});
			buttonLabel.tint = 0x0;
			buttonLabel.maxWidth = 300;
			buttonLabel.anchor.set(0.5);
			this._competitionFrame.addChild(buttonLabel);

			this._greenParticles = new ParticleEmitter('particle_endlvl_green', [
				P3.assets.texture('particle_endlvl_green')
			], true);
			this._greenParticles.enableLoop();
			this._greenParticles.play();
			this._competitionButton.addChild(this._greenParticles);

			this._competitionButton.width = buttonLabel.width + 40;
			this._competitionButton.height = buttonLabel.height + 40;
			this._competitionButton.position.set(this._competitionButton.width * -0.5, this._competitionButton.height * -0.5);
		} else {
			this._competitionText = Text(
				`${translate('MENU.SELECT_LEVEL.COMPETITION.LOCKED').replace('$SCORE$', common.totalScore)}`, {
					font  : '26px Ahkio Thin',
					align : 'center'
				});
			this._competitionText.tint = 0xFFFFFF;
			this._competitionText.maxWidth = 350;
			this._competitionText.anchor.set(0.5);
			this._competitionFrame.addChild(this._competitionText);
		}

		const badge = new PIXI.Sprite(P3.assets.texture('collectables_splash_badge'));
		badge.anchor.set(0.5);
		this.addChild(badge);
		this._competitionFrame.badge = badge;

		if (this._competitionButton) {
			competitionPanel.height = this._competitionButton.height + 20;
		} else {
			competitionPanel.height = badge.height - 40;
		}

		this.resizeFrame();
	}

	resizeFrame() {
		const fr = this._competitionFrame;

		fr.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - fr.height - 20);
		fr.bg.position.set(common.STAGE_WIDTH * 0.5 - fr.bg.width * 0.5, fr.y - fr.bg.height * 0.5);
		fr.badge.position.set(fr.bg.x - 30, fr.y);
	}

	onResume(result) {
		this.paused = false;
		if (result === 'accepted') {
			this._competitionButton.destroy({children: true});
			this._competitionButton = null;

			this._scoreFrame = new PIXI.Container();
			this._competitionFrame.addChild(this._scoreFrame);

			this._competitionText = Text(translate('MENU.SELECT_LEVEL.COMPETITION.YOURSCORE'), {font: '24px Ahkio Thin', align: 'center'});
			this._competitionText.tint = 0xFFFFFF;
			this._competitionText.maxWidth = 380;
			this._competitionText.anchor.set(0, 0.5);
			this._competitionText.visible = false;
			this._scoreFrame.addChild(this._competitionText);

			let scoreText = Text('', {font: '28px Ahkio Regular', align: 'center'});
			scoreText.tint = 0xABF546;
			scoreText.maxWidth = 380;
			scoreText.anchor.set(0, 0.5);
			scoreText.visible = false;
			this._scoreFrame.addChild(scoreText);
			this._competitionFrame.scoreText = scoreText;

			const subheader = Text('', {font: '16px Ahkio Thin', align: 'center'});
			subheader.maxWidth = 380;
			subheader.tint = 0xFFFFFF;
			subheader.anchor.set(0.5);
			subheader.visible = false;
			this._competitionFrame.addChild(subheader);
			this._competitionFrame.subheader = subheader;

			const cookie = JSON.parse(localStorage.getItem('competition_entry'));
			new Promise((resolve, reject) => {
				this.getCompetitionEntry(cookie.payload.id, resolve, reject);
			}).then((data) => {
				this._competitionText.visible = true;
				scoreText.visible = true;
				subheader.visible = true;

				common.competitionData = data.payload;
				scoreText.text = `${data.payload.score}`;
				subheader.text = translate('MENU.SELECT_LEVEL.COMPETITION.PARENTAL_CONSENT');

				this._competitionFrame.bg.height = this._competitionFrame.badge.height - 40;
				scoreText.position.set(this._competitionText.x + this._competitionText.width + 10, this._competitionText.y);
				this._scoreFrame.position.set(this._scoreFrame.width * -0.5, this._competitionFrame.bg.height * -0.5 + 30);
				subheader.position.set(0, 20);

				this.resizeFrame();
			}).catch((data) => {
				console.error('Failed setting competition entry', data);
			});
		} else {
			this._competitionButton.visible = true;
		}
	}

	showCompetitionOverlay() {
		this.signals.pause.dispatch();
	}

	getCompetitionEntry(id, resolve, reject) {
		$.ajax({
			url  : 'https://jr9huo6y8e.execute-api.eu-west-1.amazonaws.com/testing/ben10-entry',
			type : 'POST',
			data : JSON.stringify({
				message: {
					payload: {
						id: id
					},
					type: 'get_entry'
				}
			}),
			dataType    : 'json',
			crossDomain : true,
			contentType : 'application/json',
			success     : (result) => {
				resolve(Object.assign({}, {type: 'success', payload: result}));
			},
			error: (err) => {
				reject({type: 'error', msg: 'An Error has occured when getting user entry', error: err});
			}
		});
	}

	onPointerDown(event) {
		this._pointermoved = false;
		this._pointerdown = true;
		this._originalPoint	= event.data.getLocalPosition(this);
		this._lastX = this._originalPoint.x;
		this._containerPoint.copy(this._levelcontainer.position);
	}

	animateIn() {
		super.animateIn();
		this._scrollindex = common.currentLevel;
		this.scrollTween(1);
		P3.audio.playMusic('music_levels_loop_00');
	}

	onPointerUp() {
		this._pointerdown = false;

		if (this._pointermoved) {
			if (!this._closestLevel) {
				this._closestLevel = {distance: 0, level: this._levelArray[0]};
			}

			if (this._scrollindex !== this._closestLevel.level.index) {
				new P3.utils.TWEEN.Tween(this._levelArray[this._scrollindex], this.tweens)
					.to({
						y: '+50'
					}, 100)
					.easing(P3.utils.TWEEN.Easing.Linear.None)
					.start();

				this._scrollindex = this._closestLevel.level.index;

				new P3.utils.TWEEN.Tween(this._levelArray[this._scrollindex], this.tweens)
					.to({
						y: '-50'
					}, 100)
					.easing(P3.utils.TWEEN.Easing.Linear.None)
					.start();

				if (this._levels[this._scrollindex].path.includes('laboratory')) {
					this._levelBG.texture = this._levelBGAlts[0];
				} else if (this._levels[this._scrollindex].path.includes('mayan_temple')) {
					this._levelBG.texture = this._levelBGAlts[1];
				} else if (this._levels[this._scrollindex].path.includes('mine')) {
					this._levelBG.texture = this._levelBGAlts[2];
				}
			}

			new P3.utils.TWEEN.Tween(this._levelcontainer, this.tweens)
				.to({
					x: this._levelcontainer.x + this._closestLevel.distance
				}, 200)
				.easing(P3.utils.Easing.Back2.Out)
				.start();
		}
	}

	onPointerMove(event) {
		if (this._pointerdown && !(this._leftButton.isPressed || this._rightButton.isPressed)) {
			const local = event.data.getLocalPosition(this);
			const dist = local.x - this._lastX;

			this._lastX = local.x;

			this._levelcontainer.x += dist;

			if (Math.abs(this._originalPoint.x - local.x) > 5) {
				this._pointermoved = true;
			}

			let d = Infinity;

			for (const level of this._levelcontainer.children) {
				const childGlobal = level.toGlobal(new PIXI.Point(0, 0));

				const dist = (P3.View.width * 0.5) - childGlobal.x;

				if (Math.abs(dist) < d) {
					d = dist;
					this._closestLevel = {distance: dist, level: level};
				}
			}
		}
	}

	onHomeClick() {
		this.signals.previous.dispatch(this);
	}

	onLevelSelect(level) {
		this.signals.next.dispatch(level);
	}

	onNextButtonClick() {
		if (this._scrollindex >= this._levelArray.length - 1 || this._pointermoved) {
			return;
		}

		this._scrollindex++;
		this.scrollTween(-1);
	}

	onPrevButtonClick() {
		if (this._scrollindex <= 0 || this._pointermoved) {
			return;
		}

		this._scrollindex--;
		this.scrollTween(1);
	}

	scrollTween() {
		if (this._levels[this._scrollindex].path.includes('laboratory')) {
			this._levelBG.texture = this._levelBGAlts[0];
		} else if (this._levels[this._scrollindex].path.includes('mayan_temple')) {
			this._levelBG.texture = this._levelBGAlts[1];
		} else if (this._levels[this._scrollindex].path.includes('mine')) {
			this._levelBG.texture = this._levelBGAlts[2];
		}

		for (let i = 0; i < this._levelArray.length; i++) {
			let dest = i === this._scrollindex ? -50 : 0;

			new P3.utils.TWEEN.Tween(this._levelArray[i], this.tweens)
				.to({
					y: dest
				}, 250)
				.easing(P3.utils.TWEEN.Easing.Linear.None)
				.start();
		}

		new P3.utils.TWEEN.Tween(this._levelcontainer, this.tweens)
			.to({
				x: (common.STAGE_WIDTH * 0.5) + -(this._levelArray[this._scrollindex].x)
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.start();
	}

	destroy() {
		P3.audio.stopMusic();
		super.destroy();
	}

	update() {
		super.update();

		this._greenParticles && this._greenParticles.update();

		if (this._leftButton.isPressed || this._rightButton.isPressed) {
			const distance = Math.abs(this._containerPoint.x - this._levelcontainer.x);
			const direction = this._leftButton.isPressed ? 1 : -1;
			const factor = 20;
			let d = Infinity;

			if (distance >= 120) {
				this._pointermoved = true;
			}

			this._levelcontainer.x += direction * factor;

			for (const level of this._levelcontainer.children) {
				const childGlobal = level.toGlobal(new PIXI.Point(0, 0));

				const dist = (P3.View.width * 0.5) - childGlobal.x;

				if (Math.abs(dist) < d) {
					d = dist;
					this._closestLevel = {distance: dist, level: level};
				}
			}
		}

		if (this._levelcontainer.x > (common.STAGE_WIDTH * 0.5)) {
			this._levelcontainer.x = (common.STAGE_WIDTH * 0.5);
		}

		if (this._levelcontainer.x < -this._levelcontainer.width + (common.STAGE_WIDTH * 0.5)) {
			this._levelcontainer.x = -this._levelcontainer.width + (common.STAGE_WIDTH * 0.5);
		}
	}

	resize() {
		super.resize();
		this._muteButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 75, 75);
		this._homeButton.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 75, 75);
		this._leftButton.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 50, common.STAGE_HEIGHT - 250);
		this._rightButton.position.set(((common.STAGE_WIDTH + P3.View.width) * 0.5) - 50, common.STAGE_HEIGHT - 250);

		this._leftButton.hitArea = new PIXI.Rectangle(-150, -this._leftButton.y + 120, 300, P3.View.height - 120);
		this._rightButton.hitArea = new PIXI.Rectangle(-150, -this._leftButton.y + 120, 300, P3.View.height - 120);

		this._levelBG.scale.set(P3.View.width / this._levelBG.texture.width);
	}

	onPause() {
		this.paused = true;
	}
}
